"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clipboardMin = _interopRequireDefault(require("clipboard/dist/clipboard.min.js"));

var _icon = _interopRequireDefault(require("../icon"));

var _popover = _interopRequireDefault(require("../popover"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FEEDBACK_TIME = 800;
/**
 * A button that, when clicked, copies the designated text to the clipboard.
 *
 * The static function `CopyButton.isCopySupported` returns a boolean
 * indicating whether the current browser will support automatic copying.
 * If it does not, you might want to hide your copy button and make sure
 * the user is able to manually select and copy the text.
 */

var CopyButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CopyButton, _React$PureComponent);

  function CopyButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CopyButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CopyButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      showingFeedback: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCopyButtonClick", function (event) {
      // Clipboard.js attaches its own click handlers for copying
      var _this$props = _this.props,
          onCopy = _this$props.onCopy,
          text = _this$props.text;

      if (onCopy) {
        onCopy(text);
      }

      _this.showFeedback();

      _this.destroyClipboard(); // destroy clipboard


      if (event) _this.setClipboard(event.target); // reinitialize clipboard
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showFeedback", function () {
      _this.setState({
        showingFeedback: true
      });

      _this.revertTimer = setTimeout(function () {
        _this.setState({
          showingFeedback: false
        });
      }, FEEDBACK_TIME);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setContainer", function (element) {
      if (!element) return;
      var textEl = _this.props.textEl;
      _this.container = element;

      if (!textEl && _clipboardMin.default.isSupported()) {
        _this.setClipboard(element);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getContainer", function () {
      return _this.container;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "destroyClipboard", function () {
      if (_this.clipboard) {
        _this.clipboard.destroy();
      }
    });

    return _this;
  }

  _createClass(CopyButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.textEl && _clipboardMin.default.isSupported()) {
        this.setClipboard(this.props.textEl);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.revertTimer);
      this.destroyClipboard();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var copyAvailable = _clipboardMin.default.isSupported();

      if (nextProps.textEl !== this.props.textEl && copyAvailable) {
        this.setClipboard(nextProps.textEl);
      }

      if (!copyAvailable) {
        this.destroyClipboard();
      }
    }
  }, {
    key: "setClipboard",
    value: function setClipboard(element) {
      var focusTrapPaused = this.props.focusTrapPaused;
      this.clipboard = new _clipboardMin.default(element, _objectSpread({}, !focusTrapPaused && {
        container: element
      }));
    }
  }, {
    key: "renderFeedbackPopover",
    value: function renderFeedbackPopover() {
      var state = this.state;

      if (!state.showingFeedback) {
        return null;
      }

      return _react.default.createElement(_popover.default // We don't need this one to be as accessible as a regular tooltip
      , {
        getAnchorElement: this.getContainer,
        placement: "top",
        alignment: "center",
        hideWhenAnchorIsOffscreen: true,
        accessibleTitle: null,
        padding: "small"
      }, _react.default.createElement("div", {
        className: "txt-s"
      }, "Copied!"));
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props,
          state = this.state; // don't render the button if you can't use it to copy,
      // or are in Node during a static build

      if (typeof document !== 'undefined' && !_clipboardMin.default.isSupported()) {
        return null;
      }

      var iconName = state.showingFeedback ? 'check' : 'clipboard';
      var buttonClasses = (0, _classnames.default)(props.className, {
        block: props.block
      }); // data-clipboard-text and the container ref are used by clipboard.js
      // to copy text if you do not pass in a textEl as a prop.
      // Note that this wont have as nice a failure mode.

      return _react.default.createElement(_tooltip.default, {
        disabled: state.showingFeedback,
        content: "Copy",
        block: props.block
      }, _react.default.createElement("button", _extends({
        "aria-label": "Copy",
        type: "button",
        className: buttonClasses
      }, props.passthroughProps, {
        ref: this.setContainer,
        "data-clipboard-text": props.text,
        onClick: this.handleCopyButtonClick
      }), _react.default.createElement(_icon.default, {
        name: iconName
      }), this.renderFeedbackPopover()));
    }
  }]);

  return CopyButton;
}(_react.default.PureComponent);

exports.default = CopyButton;
CopyButton.propTypes = {
  /**
   * The text that will be copied when the button is clicked.
   */
  text: _propTypes.default.string.isRequired,

  /**
   * Pass in an element containing text to copy instead of the raw text
   * to provide a better fallback, where the text is selected for you if
   * `execcopy` is not supported.
   */
  textEl: _propTypes.default.object,

  /**
   * Invoked when the button is clicked.
   * Passed one argument: the `text` prop.
   */
  onCopy: _propTypes.default.func,

  /**
   * If `true`, the element will be `block` displayed instead of `inline-block`.
   *
   * This is sometimes necessary to get your pixel-perfect layout, if you don't
   * want the extra line-height that wraps inline elements. Typically, you
   * should only set `block` to `true` if the parent element is controlling
   * width (in a layout that uses flexbox, absolute positioning, or floats).
   */
  block: _propTypes.default.bool,

  /**
   * If `true`, this will allow interaction with elements outside of the
   * modal container. You normally don't want to set this, but it can be
   * useful for nesting different components that are displaced to other
   * parts of the DOM.
   */
  focusTrapPaused: _propTypes.default.bool,

  /**
   * The `className` prop of the `<button>`.
   */
  className: _propTypes.default.string,

  /**
   * An object of props that you want to pass through to the `<button>`.
   */
  passthroughProps: _propTypes.default.object
};
CopyButton.defaultProps = {
  className: 'btn btn--xs py3 px3 round',
  block: false
};

CopyButton.isCopySupported = function () {
  return _clipboardMin.default.isSupported();
};